// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blocked-suppliers__text[data-v-c339ef1c] {\n  margin-top: 15px;\n}\n.blocked-suppliers__select[data-v-c339ef1c] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
